export * from 'SourceComponent/Header/Header.config';

export const MENU_MOBILE = 'MOBILE_MENU';
